import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ref, setRef] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const r = params.get("ref");
    if (r) localStorage.setItem("pokedrop_ref", r);
    setRef(localStorage.getItem("pokedrop_ref"));

    const token = localStorage.getItem("pokedrop_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => {
      localStorage.removeItem("pokedrop_token");
      setUser(false);
    });
  }, []);

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; }
    catch { return null; }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pokedrop_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password, name, refCode) => {
    const { data } = await api.post("/auth/register", {
      email, password, name, ref: refCode || localStorage.getItem("pokedrop_ref") || undefined,
    });
    localStorage.setItem("pokedrop_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("pokedrop_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ref, login, signup, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
